import is from 'is_js';
import React from 'react';
import { FaLocationArrow, FaLocationDot } from 'react-icons/fa6';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';

function LocationIcon({ disabled }) {
  const classes = useStyles({ disabled });

  if (is.ios() || is.mac()) {
    return <FaLocationArrow className={classes.icon} />;
  }

  return <FaLocationDot className={classes.icon} />;
}

const useStyles = createUseStyles({
  icon: {
    opacity: ({ disabled }) => (disabled ? layoutDefaults.opacity : 1),
  },
});

export { LocationIcon };
